import {
  addMessages,
  locale,
  _,
  init,
  getLocaleFromNavigator,
  dictionary,
  time,
  date
} from 'svelte-i18n'

import { get } from 'svelte/store'

import { createLocalStorage, getLocalStorage, LANG_STORAGE_NAME } from './storageUtils'

import en from '../../locales/en.json'
import es from '../../locales/es.json'
import fr from '../../locales/fr.json'
import de from '../../locales/de.json'

const getLang = () => {
  let lang = getLocalStorage(LANG_STORAGE_NAME);
  if (lang) {
    console.debug("Lang from storage: " + lang);
    return lang;
  }
  lang = getLocaleFromNavigator()?.split('-')[0];
  if (lang) {
    console.debug("Lang from navigator: " + lang);
    return lang;
  }
  console.debug("Lang from default: es");
  return 'es';
}

const setLang = lang => {
  locale.set(lang)
  createLocalStorage({name: LANG_STORAGE_NAME, value: lang})
}

function setupI18n() {
  addMessages('en', en)
  addMessages('es', es)
  addMessages('fr', fr)
  addMessages('de', de)
  
  init({
    initialLocale: getLang(),
    fallbackLocale: 'es',
  })
}

let langs = [
  {
    name: 'English',
    code: 'en'
  },
  {
    name: 'Castellano',
    code: 'es'
  },
  {
    name: 'Français',
    code: 'fr'
  },
  {
    name: 'Deutsch',
    code: 'de'
  }
].map(l => ({ ...l, action: function () { setLang(l.code) } }))

const translate = id => get(_)(id)

const getTranslation = (dict,search) => {
  const keys = search.split('.');
  let result = dict;
  keys.forEach(key => {
    result = result[key];
  });
  return result;
}

const translateRaw = id => {
  switch (getLang()) {
    case 'en':
      return getTranslation(en, id);
    // case 'fr':
      //   return fr[id];
    case 'es':
    default:
      return getTranslation(es, id);
  }
}

export {
  _,
  setLang,
  getLang,
  setupI18n,
  dictionary as allLangs,
  locale,
  langs,
  LANG_STORAGE_NAME,
  translate,
  time,
  date
}